<template>
  <div id="pattern-vue" class="container">
  <h5 class="mt-3">パターンの検索</h5>
    <div class="row">
      <div v-for="(i, idx) in Array(queryCnt)" class="col-12 mt-3 col-lg-6" :key="idx">
        <div class="card">
          <div class="row p-3">
            <div class="col-12">条件{{ idx + 1 }}
              <span class="float-right">
                <b-button variant=danger size="sm"
                  :disabled="queryCnt == 1" @click="delQuery(idx)">
                  <font-awesome-icon icon="minus"/>
                </b-button>
              </span>
            </div>
            <div class="mt-1 col-6">
              プレイヤー
              <b-form-select class="shadow-sm" v-model="selectedPlayer[idx]"
                :options="playerList" size="sm" />
            </div>
            <div class="mt-1 col-6">
              ラリー数
              <b-form-select class="shadow-sm" v-model="selectedRallyCnt[idx]"
                :options="rallyCntList" size="sm" />
            </div>
            <div class="mt-1 col-6">
              フォア・バック
              <b-form-select class="shadow-sm" v-model="selectedForeBack[idx]"
                :options="foreBackList" size="sm" />
            </div>
            <div v-if="selectedRallyCnt[idx] > 0" class="mt-1 col-6">
              ↑ ラリー数と
              <b-form-select class="shadow-sm" v-model="selectedSearchMode[idx]"
                :options="searchModeList" size="sm" />
            </div>
            <div class="mt-1 col-6">
              コース
              <b-form-select class="shadow-sm" v-model="selectedCourse[idx]"
                :options="courseList" size="sm" />
            </div>
            <div v-if="selectedRallyCnt[idx] == 0" class="mt-1 col-6">
              サーブの種類
              <b-form-select class="shadow-sm" v-model="selectedHit[idx]"
                :options="hitsListOnServe" size="sm" />
            </div>
            <div v-else class="mt-1 col-6">
              打法
              <b-form-select class="shadow-sm" v-model="selectedHit[idx]"
                :options="hitsList" size="sm" />
            </div>
            <div class="mt-1 col-6">
              イン・アウト
              <b-form-select class="shadow-sm" v-model="selectedInOut[idx]"
                :options="InOutList" size="sm" />
            </div>
            <div v-if="selectedRallyCnt[idx] == 0" class="mt-1 col-6">
              サーブ打球位置
              <b-form-select class="shadow-sm" v-model="selectedHitPosition[idx]"
                :options="hitPositionListOnServe" size="sm" />
            </div>
            <div v-else class="mt-1 col-6">
              打球位置
              <b-form-select class="shadow-sm" v-model="selectedHitPosition[idx]"
                :options="hitPositionList" size="sm" />
            </div>
            <div v-if="selectedInOut[idx] == 0" class="mt-1 col-6">
              アウト詳細
              <b-form-select class="shadow-sm" v-model="selectedInOutDetail[idx]"
                :options="outDetailList" size="sm" />
            </div>
            <div v-if="selectedInOut[idx] == 1" class="mt-1 col-6">
              イン詳細
              <b-form-select class="shadow-sm" v-model="selectedInOutDetail[idx]"
                :options="inDetailList" size="sm" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-3 text-center">
        <b-button variant="primary" @click="addQuery()">
          <font-awesome-icon icon="plus"/>
        </b-button>
      </div>
    </div>
    <div v-if="targetHitsList.length > 0">
      <DetailDataCard
        :title="'ヒットしたパターンの得点数'"
        :player1Name="this.game.gameInfo.player1Name"
        :player2Name="this.game.gameInfo.player2Name"
        :data="scoreCount"/>
      <ScoreRateOnSelectPoint :gameInfo="game.gameInfo" :points="selectPoints" />
      <div class="row mt-5">
        <div v-for="(obj, idx) in targetHitsList" class="col-12 mt-3" :key="idx">
          {{ obj.score }}
          <HitsTable :hits="game.hitsList[obj.idx]" :gameInfo="game.gameInfo"
            :isHeader="false" :label="game.labels[obj.idx]" />
        </div>
      </div>
    </div>
    <div v-else class="mt-5 text-center">
      条件にヒットするラリーが存在しません
    </div>
    <div class="row mt-5">
      <div class="col-12 text-center">
        <b-button variant="outline-secondary" class="btn">
          <div class="text-dark" @click="$router.go(-1);">データページへ戻る</div>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CmnConst from '@/lib/cmnConst';
import func from '@/lib/func';
import HitsTable from '@/components/molecules/HitsTable';
import DetailDataCard from '@/components/molecules/DetailDataCard';
import ScoreRateOnSelectPoint from '@/components/molecules/ScoreRateOnSelectPoint';

export default {
  name: 'pattern-',
  components: {
    HitsTable,
    DetailDataCard,
    ScoreRateOnSelectPoint,
  },
  data() {
    return {
      selectedPlayer: [1],
      selectedRallyCnt: [0],
      selectedForeBack: [-1],
      selectedCourse: [-1],
      selectedHit: [-1],
      selectedInOut: [-1],
      selectedHitPosition: [-1],
      selectedInOutDetail: [-1],
      selectedSearchMode: [0],
      queryCnt: 1,
      InOutList: [
        { value: -1, text: '未選択' },
        { value: 1, text: 'イン' },
        { value: 0, text: 'アウト' },
      ],
      searchModeList: [
        { value: 0, text: '等しい' },
        { value: 1, text: '以降' },
        { value: 2, text: '以前' },
      ],
    };
  },
  computed: {
    foreBackList() {
      const options = [];
      options.push({ value: -1, text: '未選択' });
      for (let i = 0; i < CmnConst.handList.length; i++) {
        options.push({ value: i, text: CmnConst.handList[i] });
      }
      return options;
    },
    courseList() {
      const options = [];
      options.push({ value: -1, text: '未選択' });
      for (let i = 0; i < CmnConst.courseList.length; i++) {
        options.push({ value: i, text: CmnConst.courseList[i] });
      }
      return options;
    },
    hitsListOnServe() {
      const options = [];
      options.push({ value: -1, text: '未選択' });
      for (let i = 0; i < CmnConst.serveList.length; i++) {
        options.push({ value: i, text: CmnConst.serveList[i] });
      }
      return options;
    },
    hitsList() {
      const options = [];
      options.push({ value: -1, text: '未選択' });
      for (let i = 0; i < CmnConst.hitsStyleList.length; i++) {
        options.push({ value: i, text: CmnConst.hitsStyleList[i] });
      }
      return options;
    },
    playerList() {
      const options = [];
      options.push({ value: 1, text: this.game.gameInfo.player1Name });
      options.push({ value: 2, text: this.game.gameInfo.player2Name });
      return options;
    },
    rallyCntList() {
      const options = [];
      const maxLabels = Math.max(...this.game.labels);
      for (let i = 0; i <= maxLabels; i++) {
        let text = `${i + 1}球目`;
        if (i === 0) {
          text = 'サーブ';
        } else if (i === 1) {
          text = 'レシーブ';
        }
        options.push({ value: i, text });
      }
      return options;
    },
    hitPositionList() {
      const options = [];
      options.push({ value: -1, text: '未選択' });
      for (let i = 0; i < CmnConst.hitPostion.length; i++) {
        options.push({ value: i, text: CmnConst.hitPostion[i] });
      }
      return options;
    },
    hitPositionListOnServe() {
      const options = [];
      options.push({ value: -1, text: '未選択' });
      for (let i = 0; i < CmnConst.hitPostionAtServe.length; i++) {
        options.push({ value: i, text: CmnConst.hitPostionAtServe[i] });
      }
      return options;
    },
    inDetailList() {
      const options = [];
      options.push({ value: -1, text: '未選択' });
      for (let i = 0; i < CmnConst.inList.length; i++) {
        options.push({ value: i, text: CmnConst.inList[i] });
      }
      return options;
    },
    outDetailList() {
      const options = [];
      options.push({ value: -1, text: '未選択' });
      for (let i = 0; i < CmnConst.outList.length; i++) {
        options.push({ value: i, text: CmnConst.outList[i] });
      }
      return options;
    },
    targetHitsList() {
      const ret = [];
      let info = { p1: 0, p2: 0, s1: 0, s2: 0, nextSv: 0 };
      // ポイントごとのループ
      for (let i = 0; i < this.game.points.length; i++) {
        let result = true;
        const hits = this.game.hitsList[i];
        // 全条件をループで回して、全条件に当てはまるか検索
        for (let selectedIdx = 0; selectedIdx < this.selectedRallyCnt.length; selectedIdx++) {
          const rallyCnt = this.game.labels[i];
          const startIdx = hits.player.length - rallyCnt - 1;
          const targetIdx = startIdx + this.selectedRallyCnt[selectedIdx];
          if (hits.player.length <= targetIdx) {
            result = false;
            break;
          }
          // 1件のみの検索のときも検索用のインデックス番号を用意してから、
          // 複数の打球を検索する場合と同じように検索する
          let searchIdx = [];
          if (this.selectedRallyCnt[selectedIdx] === 0) {
            // サーブのとき
            searchIdx = [...Array(targetIdx + 1).keys()];
          } else if (this.selectedSearchMode[selectedIdx] === 0) {
            // 等しい場合
            searchIdx = [targetIdx];
          } else if (this.selectedSearchMode[selectedIdx] === 1) {
            // 以降の場合
            for (let k = targetIdx; k < hits.player.length; k++) {
              searchIdx.push(k);
            }
          } else if (this.selectedSearchMode[selectedIdx] === 2) {
            // 以前の場合
            for (let k = startIdx + 1; k <= targetIdx; k++) {
              searchIdx.push(k);
            }
          }
          const found = searchIdx.find(element => this.judge(hits, selectedIdx, element));
          result = found !== undefined;
          if (!result) {
            break;
          }
        }
        if (result) {
          ret.push({
            idx: i,
            server: hits.player[0],
            score: `${info.s1 + info.s2 + 1}ゲーム目 ${info.p1} - ${info.p2}`,
          });
        }
        info = func.nextPoint(info, this.game.points[i]);
      }
      return ret;
    },
    selectPoints() {
      const ret = [];
      for (let i = 0; i < this.targetHitsList.length; i++) {
        ret.push(this.game.points[this.targetHitsList[i].idx]);
      }
      return ret;
    },
    scoreCount() {
      const all = this.targetHitsList.length;
      const player1 = func.sumArr(this.selectPoints);
      const player2 = all - player1;
      return [[`${player1} / ${all}`, `${player2} / ${all}`]];
    },
    ...mapGetters([
      'game',
    ]),
  },
  methods: {
    delQuery(idx) {
      this.selectedPlayer.splice(idx, 1);
      this.selectedRallyCnt.splice(idx, 1);
      this.selectedForeBack.splice(idx, 1);
      this.selectedCourse.splice(idx, 1);
      this.selectedHit.splice(idx, 1);
      this.selectedInOut.splice(idx, 1);
      this.selectedHitPosition.splice(idx, 1);
      this.selectedInOutDetail.splice(idx, 1);
      this.selectedSearchMode.splice(idx, 1);
      this.queryCnt -= 1;
    },
    addQuery() {
      this.selectedPlayer.push(1);
      this.selectedRallyCnt.push(0);
      this.selectedForeBack.push(-1);
      this.selectedCourse.push(-1);
      this.selectedHit.push(-1);
      this.selectedInOut.push(-1);
      this.selectedHitPosition.push(-1);
      this.selectedInOutDetail.push(-1);
      this.selectedSearchMode.push(0);
      this.queryCnt += 1;
    },
    judge(hits, selectedIdx, targetIdx) {
      if (this.selectedPlayer[selectedIdx] !== hits.player[targetIdx]) {
        return false;
      }
      if ((this.selectedForeBack[selectedIdx] >= 0)
        && (this.selectedForeBack[selectedIdx] !== hits.hand[targetIdx])) {
        return false;
      }
      if ((this.selectedCourse[selectedIdx] >= 0)
        && (this.selectedCourse[selectedIdx] !== hits.course[targetIdx])) {
        return false;
      }
      if ((this.selectedHit[selectedIdx] >= 0)
        && (this.selectedHit[selectedIdx] !== hits.hitStyle[targetIdx])) {
        return false;
      }
      if ((this.selectedInOut[selectedIdx] >= 0)
        && (Boolean(this.selectedInOut[selectedIdx]) !== hits.inOut[targetIdx])) {
        return false;
      }
      if ((this.selectedHitPosition[selectedIdx] >= 0)
        && (this.selectedHitPosition[selectedIdx] !== hits.hitPosition[targetIdx])) {
        return false;
      }
      if ((this.selectedInOutDetail[selectedIdx] >= 0)
        && (this.selectedInOutDetail[selectedIdx] !== hits.inOutDetail[targetIdx])) {
        return false;
      }
      return true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Pattern.vue